import { createTheme } from '@mui/material/styles';

/* Design tokens from CAUREX_REACT_SPEC.md */
export const tokens = {
  ink: '#122019',
  paper: '#FBFBF9',
  cream: '#F2F5F2',
  dark: '#10281F',
  dark2: '#173A2D',
  teal: '#2FA97E',
  tealDeep: '#1F7C5B',
  orange: '#C8860F',
  blue: '#22588E',
  red: '#B23A2F',
  line: 'rgba(18, 32, 25, 0.10)',
  lineOnDark: 'rgba(255, 255, 255, 0.14)',
  muted: '#5B6B62',
  mutedOnDark: '#AFC7BB',
};

export const displayFont = "system-ui, sans-serif";
export const bodyFont = "system-ui, sans-serif";
export const monoFont = "system-ui, sans-serif";

const theme = createTheme({
  breakpoints: {
    /* Spec breakpoints: stack below 860, simplify further below 520; container 1120 */
    values: { xs: 0, sm: 520, md: 860, lg: 1120, xl: 1536 },
  },
  palette: {
    primary: { main: tokens.teal, dark: tokens.tealDeep, contrastText: '#fff' },
    warning: { main: tokens.orange },
    error: { main: tokens.red },
    info: { main: tokens.blue },
    background: { default: tokens.paper, paper: tokens.paper },
    text: { primary: tokens.ink, secondary: tokens.muted },
    divider: tokens.line,
  },
  shape: { borderRadius: 2 },
  typography: {
    fontFamily: bodyFont,
    h1: {
      fontFamily: displayFont,
      fontWeight: 700,
      lineHeight: 1.15,
      letterSpacing: '-0.01em',
      fontSize: 'clamp(2rem, 4.5vw, 3.25rem)',
    },
    h2: {
      fontFamily: displayFont,
      fontWeight: 700,
      lineHeight: 1.15,
      letterSpacing: '-0.01em',
      fontSize: 'clamp(1.5rem, 3vw, 2.25rem)',
    },
    h3: { fontFamily: displayFont, fontWeight: 600, fontSize: '1.15rem', lineHeight: 1.3 },
    h4: { fontFamily: displayFont, fontWeight: 600, fontSize: '1rem', lineHeight: 1.3 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButton: { defaultProps: { disableElevation: true } },
    MuiButtonBase: { defaultProps: { disableRipple: false } },
  },
});

export default theme;
